export const DASHBOARD_SOURCE = 'messagingAccounts-dashboard';

export const MODAL_SOURCE = 'messagingAccounts-modal';

export const DEFAULT_SORT = 'name,asc';

export const AVAILABLE_PAGE_SIZE = 20;

export const SMS_PHONE_NUMBERS_MAX_LENGTH = 10;
